import { render, staticRenderFns } from "./UIFrame.vue?vue&type=template&id=70790a47&scoped=true&"
import script from "./UIFrame.vue?vue&type=script&lang=js&"
export * from "./UIFrame.vue?vue&type=script&lang=js&"
import style0 from "./UIFrame.vue?vue&type=style&index=0&id=70790a47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70790a47",
  null
  
)

export default component.exports